//@ts-check
///<reference path="../../assets/src/js/carousel.d.ts" />
'use strict';

import { GenericCarousel } from '../../assets/src/js/carousel.js';


window.addEventListener('load', function(_) {
	const BASE_CLASS = 'chronicles';
	// FROZEN contract: the backend toggles this exact active class.
	const FILTER_ACTIVE_CLASS = BASE_CLASS + '__filter-button--active';

	let blocks = document.querySelectorAll('.' + BASE_CLASS);

	for(const block of blocks) {
		/** @type {HTMLElement | null} */
		const carousel = block.querySelector('.' + BASE_CLASS + '__carousel');
		if(!carousel) {
			continue;
		}

		/** @type {HTMLElement | null} */
		const track = carousel.querySelector('.' + BASE_CLASS + '__carousel--track');
		if(!track) {
			continue;
		}

		/** @type {NodeListOf<HTMLElement>} */
		const carousel_items = track.querySelectorAll('.' + BASE_CLASS + '__post');
		if(!carousel_items.length) {
			continue;
		}


		/** @type {HTMLElement | null} */
		const nav = block.querySelector('.' + BASE_CLASS + '-navigation-wrapper');
		if(!nav) {
			continue;
		}

		/** @type {NodeListOf<import('../../assets/src/js/carousel.js').GenericCarouselButton>} */
		const nav_prev = nav.querySelectorAll('.' + BASE_CLASS + '-prev');
		if(!nav_prev.length) {
			continue;
		}

		/** @type {NodeListOf<import('../../assets/src/js/carousel.js').GenericCarouselButton>} */
		const nav_next = nav.querySelectorAll('.' + BASE_CLASS + '-next');
		if(!nav_next.length) {
			continue;
		}

		/** @type {HTMLElement | null} */
		const nav_dots = nav.querySelector('.' + BASE_CLASS + '-dots');
		if(!nav_dots) {
			continue;
		}


		/** @type {HTMLElement | null} */
		const filter = block.querySelector('.' + BASE_CLASS + '__filter');
		if(!filter) {
			continue;
		}

		/** @type {NodeListOf<HTMLButtonElement>} */
		const filter_buttons = filter.querySelectorAll('button');
		if(!filter_buttons.length) {
			continue;
		}


		/** @type {HTMLButtonElement | null} */
		let filter_button_active = Array.from(filter_buttons)
			.filter(button => button.classList.contains(FILTER_ACTIVE_CLASS))[0];

		if(!filter_button_active) {
			filter_button_active = filter_buttons[0];
			filter_button_active.classList.add(FILTER_ACTIVE_CLASS);
			filter_button_active.setAttribute('aria-pressed', 'true');
		}


		const gc = new GenericCarousel({
			// Switch mobile<->desktop at 1023px so the JS card-step math flips at
			// the same point as the SCSS `screen-md` (min-width:1024px) override.
			// Below 1024px = mobile (242/24); at/above = desktop (330/25).
			mobileBreakpoint: 1023,
			cardsPerView: {
				mobile: 1,
				desktop: 'auto'
			},
			cardDimensions: {
				desktop: { width: 330, gap: 25 },
				mobile: { width: 242, gap: 24 },
			},
			orientation: {
				mobile: 'horizontal',
				desktop: 'horizontal',
			},
			customElements: {
				carousel: carousel,
				track: track,
				desktopNav: nav,
				mobileNav: nav,
				nextBtns: nav_next,
				prevBtns: nav_prev,
				dotsContainer: nav_dots,
				dotsContainerMobile: nav_dots,
			}
		});


		/**
		 * Handles swapping the filters.
		 *
		 * Mechanic mirrors betting-tips-carousel 1:1 — empty button value === "All"
		 * (show everything), otherwise match button.value against item data-type.
		 *
		 * @param {MouseEvent} e The button click event
		 *
		 * @returns {void}
		 */
		function filter_handler(e) {
			const button_clicked = e.target;

			// Not a handlable thing - return
			if(!button_clicked || !(button_clicked instanceof HTMLButtonElement)) {
				return;
			}

			// Same button - do nothing
			if(button_clicked === filter_button_active) {
				return;
			}

			filter_button_active?.classList.remove(FILTER_ACTIVE_CLASS);
			filter_button_active?.setAttribute('aria-pressed', 'false');
			button_clicked.classList.add(FILTER_ACTIVE_CLASS);
			button_clicked.setAttribute('aria-pressed', 'true');

			filter_button_active = button_clicked;

			carousel_items.forEach(function truncate_items(item) {
				item.parentElement?.removeChild(item)
			});

			carousel_items.forEach(function reveal_items(item) {
				if(
					filter_button_active?.value !== ''
					&& filter_button_active?.value !== item.getAttribute('data-type')
				) {
					return;
				}

				track?.appendChild(item);
			});

			gc.refresh();
		}

		filter_buttons.forEach(button => button.addEventListener('click', filter_handler));
	}
});
